////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { isNull, find, isUndefined } from 'lodash'
///////COMPONENTS///////
import { kioskBusinessRequestStatusPicsConfig } from '../../../constants/AssetsPicturesConfigList'
/////////ASSETS/////////
import check from '../../../assets/icones/global/check.svg'

/////////STYLED/////////
const InitKioskBusinessRequestStatusImgWrapper = styled.div`
	width: 32px;
	height: 32px;
	margin: auto;
	position: relative;
	& > img {
		position: absolute;
		left: 0px;
	}
`
const InitKioskBusinessRequestStatusOverflow = styled.div`
	width: 162px;
	position: relative;
	overflow: hidden;
	border: 1px solid ${(props) => props.theme.colors.tabText};
	box-sizing: border-box;
	border-radius: 10px;
	height: 18px;
	margin: auto;
`
const InitKioskBusinessRequestStatusBar = styled.div`
	width: ${(props) => props.progress * 100}%;
	height: 100%;
	background: ${(props) => (props.isDisplayCheck ? `url(${check})` : null)} no-repeat center;
	background-color: ${(props) => {
		const progress = props.progress * 100

		if (progress > 0) {
			if (progress <= 10) return props.theme.colors.progressBar.colors.red
			else if (progress <= 25) return props.theme.colors.progressBar.colors.orange
			else if (progress <= 33) return props.theme.colors.progressBar.colors.lightOrange
			else if (progress <= 50) return props.theme.colors.progressBar.colors.yellow
			else if (progress <= 66) return props.theme.colors.progressBar.colors.lightCamo
			else if (progress <= 75) return props.theme.colors.progressBar.colors.camo
			else if (progress <= 90) return props.theme.colors.progressBar.colors.green
			else if (progress <= 100) return props.theme.colors.progressBar.colors.greenComplete
			else return 'transparent'
		} else return 'transparent'
	}};
`
/////////STYLED/////////

const InitKioskBusinessRequestStatus = (props) => {
	const f = find(kioskBusinessRequestStatusPicsConfig, { subFlow: !isUndefined(props?.row?.requestStatus?.subFlow) })

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<div>
			{!isUndefined(f) && isNull(props.row?.progress) ? ( //&& !isNull(props.row?.requestStatus?.picture)
				<InitKioskBusinessRequestStatusImgWrapper>
					<img src={f.picture} />
				</InitKioskBusinessRequestStatusImgWrapper>
			) : (
				<InitKioskBusinessRequestStatusOverflow>
					<InitKioskBusinessRequestStatusBar progress={props.row.progress} isDisplayCheck={props.row.canKioskAffectRequest} />
				</InitKioskBusinessRequestStatusOverflow>
			)}
		</div>
	)
}

InitKioskBusinessRequestStatus.propTypes = {}

InitKioskBusinessRequestStatus.defaultPropTypes = {}

export default InitKioskBusinessRequestStatus
